<template>
  <div>
    <!-- Encabezzado PC -->
    <v-layout row wrap  class="hidden-sm-and-down">
      <v-flex sm12 md12 >
        <v-card flat dark color="white">        
          <v-img class="header_parents"
              src="./COVER_PADRES.png"
            >
            <div class="vertical-center">
              <v-flex xs4 sm4 md4 lg4>
                <p class="text-top-rowp">
                  {{row1_text1}}
                </p>
            <div class="hidden-sm-and-down"><br></div>
              
              
              </v-flex>
              <v-flex xs4 sm4 md3 lg3>
              <v-img :src="row1_img"></v-img>
              </v-flex>
                
              <v-flex  xs3 sm3 md3 lg3>
                <br><br><br>
                <loginbutton></loginbutton>
                <!--<registerbutton></registerbutton>-->
                <!--<logoutbutton></logoutbutton>-->
              </v-flex>         
            </div>
            <v-img class="cenefa"
                src="cenefa.png" 
            />          
        </v-img>
        </v-card>
      </v-flex>
      
    </v-layout>

    <!-- Encabezado Movil -->
    <v-layout row wrap class="hidden-md-and-up">
      <v-flex sm12 md12 >
        <v-card flat dark color="white">        
          <v-img class="header_parents"
              src="./padres_cover_mobile.png" height="300px"
            >
            <div class="vertical-center-mobile">
              <v-flex xs12 sm12 md4 lg4>
                <p class="text-top-rowp" style="font-size:4vw; text-align:center; font-weight:500">
                  {{row1_text1}}
                </p>
              </v-flex>
              <v-flex xs9 sm9 md3 lg3>
              <v-img :src="row1_img" style="margin-left:29%; margin-top:-5%"></v-img>
              </v-flex> 
              <v-layout justify-center style="margin-top:-2%;margin-bottom:30px">
            <v-flex  style="padding:3vw" xs5 sm5 md6 lg6>
              <!--<a href="https://itunes.apple.com/mx/developer/laura-jorrin-arizmendi/id1089319124?mt=8" target="_blank">
              <v-img :src="row1_img1"></v-img>
              </a>-->
              <loginbutton></loginbutton>
            </v-flex>
            <!--<v-flex  style="padding:3vw" xs5 sm5 md6 lg6>
              
              <registerbutton></registerbutton>
            </v-flex>-->
            </v-layout>        
            </div>
            <v-img class="cenefa"
                src="cenefa.png" 
            />          
        </v-img>
        </v-card>
      </v-flex>
      
    </v-layout>


    <!--ROW2-->
    <v-layout row wrap style="background-color:#f7f7f7" class="hidden-sm-and-down">
      <v-flex class="pa-4" xs12 sm12 md10 lg10 offset-md1 offset-lg1>
        <p class="text-center">{{row2_text1}}</p>
        <p class="text-center sub" style="font-size:1.8vw">{{row2_text2}}</p>
        <v-layout justify-center>
        <v-flex class="tools" style="padding:3vw" xs4 sm4 md3 lg3>
            <v-img :src="row2_img1"></v-img>
            <p class="text-center text-guia">{{row2_text3}}</p>           
        </v-flex>
        <v-flex class="tools" style="padding:3vw" xs4 sm4 md3 lg3>
          <v-img :src="row2_img2"></v-img>
            <p class="text-center text-guia">{{row2_text4}}</p>
        </v-flex>
        <v-flex class="tools" style="padding:3vw" xs4 sm4 md3 lg3>
          <v-img :src="row2_img3"></v-img>
            <p class="text-center text-guia">{{row2_text5}}</p>                      
        </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- ROW2 MOVIL -->
    <v-layout row wrap style="background-color:#f7f7f7" class="hidden-md-and-up" justify-center>
      <v-flex class="pa-4" xs12 sm12 md10 lg10 >
        <p class="text-center" style="font-size:4vw; line-height:110%">{{row2_text1}}</p>
        <p class="text-center sub" style="font-size:3.8vw;margin-top:-6%">{{row2_text2}}</p>
        <v-layout justify-center>
        <v-flex class="tools" style="padding:3vw" xs6 sm6 md3 lg3>
            <v-img :src="row2_img1"></v-img>         
        </v-flex>  
        </v-layout>
        <v-layout justify-center>
        <v-flex class="tools" style="padding:3vw" xs10 sm10 md3 lg3>
            <p class="text-center text-guia" style="font-size:3.6vw">{{row2_text3}}</p>        
        </v-flex>  
        </v-layout>
        <v-layout justify-center>
        <v-flex class="tools" style="padding:3.5vw" xs6 sm6 md3 lg3>
          <v-img :src="row2_img2"></v-img>
        </v-flex>
        </v-layout>
        <v-layout justify-center>
        <v-flex class="tools" style="padding:3.5vw" xs10 sm10 md3 lg3>
          <p class="text-center text-guia" style="font-size:3.6vw">{{row2_text4}}</p>  
        </v-flex>
        </v-layout>
        <v-layout justify-center>
        <v-flex class="tools" style="padding:3.5vw" xs6 sm6 md3 lg3>
          <v-img :src="row2_img3"></v-img>                     
        </v-flex>
        </v-layout>
        <v-layout justify-center>
        <v-flex class="tools" style="padding:3.5vw" xs10 sm10 md3 lg3>
          <p class="text-center text-guia" style="font-size:3.6vw">{{row2_text5}}</p>  
        </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!--ROW3-->
    <v-layout justify-center row wrap style="background:url(baja_la_app.png); background-repeat: no-repeat; background-size: cover;" class="hidden-sm-and-down">
      <v-flex class="mt-2" xs12 sm12 md10 lg10 offset-md1 offset-lg1> 
        <p class="text-center title_3" style="color:white; font-family:Fredoka one; font-size:2.5vw; font-weight:400">{{row3_text}}</p><br>       
        <v-layout>
          
          
        <v-flex style="padding:4vw" xs5 sm5 md5 lg5>
            <p class="text-center title_3" style="color:white">{{row3_text1}}<b> {{row3_text2}}</b></p><br>
            <v-layout>
            <v-flex  xs6 sm6 md6 lg6>
              <a href="https://apps.apple.com/mx/app/mundo-lalabum/id1414963543" target="_blank">
              <v-img :src="row3_img1"></v-img>
              </a>
            </v-flex>
            <v-flex  xs6 sm6 md6 lg6>
              <a href="https://play.google.com/store/apps/details?id=com.Lalabum.MundoLalabum" target="_blank">
              <v-img :src="row3_img2"></v-img>
              </a>
            </v-flex>
            </v-layout>
        </v-flex>
        <v-flex xs6 sm6 md6 lg6>
            <v-img   src="ipad-mockup.png"/>
        </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

  <!-- ROW3 MOBILE -->
    <v-layout justify-center row wrap style="background:url(baja_la_app.png); background-repeat: no-repeat; background-size: cover;" class="hidden-md-and-up">
      <v-flex class="mt-2" xs12 sm12 md10 lg10>        
        <v-layout justify-center>     
        <v-flex style="padding:4vw" xs11 sm11 md5 lg5>
          <p class="text-center title_3" style="color:white; font-family:Fredoka one; font-size:5vw; font-weight:400">{{row3_text}}</p><br>
          <v-card color="rgba(60, 1, 60, 0.54)" style="border-radius:7px"> 

            <v-flex xs12 sm12>
            <p class="text-center title_3" style="color:white; font-size:6vw;">{{row3_text1}}<b> {{row3_text2}}</b></p><br>
            </v-flex>
            <v-layout justify-center style="margin-top:-8%">
            <v-flex  xs5 sm5 md6 lg6>
              <a href="https://apps.apple.com/mx/app/mundo-lalabum/id1414963543" target="_blank">
              <v-img :src="row3_img1"></v-img>
              </a>
            </v-flex>
            <v-flex  xs5 sm5 md6 lg6>
              <a href="https://play.google.com/store/apps/details?id=com.Lalabum.MundoLalabum" target="_blank">
              <v-img :src="row3_img2"></v-img>
              </a>
            </v-flex>
            </v-layout>
            </v-card>
        </v-flex>
        </v-layout>
        <v-layout justify-center>
        <v-flex xs6 sm6 md6 lg6>
            <v-img   src="ipad-mockup.png"/>
        </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>


    <!--ROW4-->
    <!--<v-layout justify-center row wrap style="background:url(home_back_azul.png);background-repeat: no-repeat; background-size: cover;" class="hidden-sm-and-down">
      <v-flex class="mt-2" xs12 sm12 md10 lg10 > 
        <p class="text-center title_3" style="color:white; font-family:Fredoka one; font-size:2.5vw; font-weight:400">{{row4_text1}}</p><br>       
        
        <v-layout row wrap class="hidden-sm-and-down">
      <v-flex  xs12 sm12 md12 lg12 offset-md1 offset-lg1>
        <v-layout justify-center>
        <v-flex  style="padding:1vw" xs4 sm4 md5 lg5>
            <v-img src="kit_lalabum_niña.png" style="border-radius:7px"></v-img>
            <p align="center" style="color:white;font-family:Fredoka one;font-size:2vw;font-weight:600">Kit Lalabum</p>  
            <p align="center"><a href="https://lalabumapp.com/tienda" target="_blank" style="border-radius:7px;background:#72b279;font-family:Poppins;font-size:2vw;color:white;font-weight:500;padding:5px 54px 5px 54px;text-decoration:none">Comprar</a>  </p>       
        </v-flex>
        <v-flex class="tools" style="padding:1vw" xs4 sm4 md3 lg3>-->
         <!-- <v-img :src="row2_img2"></v-img>
            <p class="text-center text-guia">{{row2_text4}}</p>-->
       <!-- </v-flex>
        <v-flex  style="padding:1vw" xs4 sm4 md5 lg5>
          <v-img src="Ciudadano_estrella_promo_plane.jpg" style="border-radius:7px"></v-img>
             <p align="center" style="color:white;font-family:Fredoka one;font-size:2vw;font-weight:200">Ciudadano Estrella</p>      
              <p align="center"><a href="https://articulo.mercadolibre.com.mx/MLM-634880171-ciudadano-estrella-_JM" target="_blank" style="border-radius:7px;background:#72b279;font-family:Poppins;font-size:2vw;color:white;font-weight:500;padding:5px 54px 5px 54px;text-decoration:none">Comprar</a>  </p>              
        </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
      </v-flex>
    </v-layout>-->

    <!--ROW4 MOBILE-->
   <!--<v-layout justify-center row wrap style="background:url(home_back_azul.png);background-repeat: no-repeat; background-size: cover;" class="hidden-md-and-up">
      <v-flex class="mt-2" xs10 sm10 md10 lg10 > 
        <p class="text-center title_3" style="color:white; font-family:Fredoka one; font-size:5vw; font-weight:400">{{row4_text1}}</p><br>       
        
        <v-layout row wrap class="hidden-md-and-up">
      <v-flex  xs12 sm12 md12 lg12 offset-md1 offset-lg1>
        <v-layout justify-center>
        <v-flex  style="padding:1vw" xs9 sm9 md5 lg5>
            <v-img src="kit_lalabum_niña.png" style="border-radius:7px"></v-img> 
            <br>
            <p align="center" style="color:white;font-family:Fredoka one;font-size:4vw;font-weight:600">Kit Lalabum</p>  
            <p align="center"><a href="https://lalabumapp.com/tienda" target="_blank" style="border-radius:7px;background:#72b279;font-family:Poppins;font-size:4vw;color:white;font-weight:500;padding:5px 30px 5px 30px;text-decoration:none">Comprar</a>  </p>       
        </v-flex>
        </v-layout>
        <v-layout justify-center>
        <v-flex  style="padding:1vw" xs9 sm9 md5 lg5>
          <br><br>
            <v-img src="Ciudadano_estrella_promo_plane.jpg" style="border-radius:7px"></v-img> 
            <br>
            <p align="center" style="color:white;font-family:Fredoka one;font-size:4vw;font-weight:600">Ciudadano Estrella</p>  
            <p align="center"><a href="https://articulo.mercadolibre.com.mx/MLM-634880171-ciudadano-estrella-_JM" target="_blank" style="border-radius:7px;background:#72b279;font-family:Poppins;font-size:4vw;color:white;font-weight:500;padding:5px 30px 5px 30px;text-decoration:none">Comprar</a>  </p>       
        </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
      </v-flex>
    </v-layout>-->


  </div>
</template>
<script>
  import loginbutton from "../components/login-button"
  import registerbutton from "../components/register-button"
  import logoutbutton from "../components/logout-button"
  
  export default {
    
    components:{
      loginbutton,
      registerbutton,
      logoutbutton
    },
    data() {
    
    let language=localStorage.getItem('language');
    if (language=='es') 
      {
        return{
          dialog: false,
          dialog2:false,        
          row1_text2:'Haz equipo con los padres de tus alumnos y balancea el tiempo en pantalla de los niños con divertidas actividades en el aula.',          
          row1_text1:'Una experiencia educativa llena de diversión y buenos ejemplos para que tus hijos aprendan valores',
          row1_img:'./bienpadres.png',
          row1_img1:'./btn__iniciarsesion.png',
          row1_img2:'./btn_registrate.png',
          row2_text1:'Guía a tus hijos por el mejor camino con Lalabum como acompañante.',
          row2_text2:'Suscríbete ahora y obtén:',
          row2_img1:'./icon_celular.png',
          row2_img2:'./icon_monitor.png',
          row2_img3:'./icon_tablet.png',
          row2_text3:'Acceso ilimitado a material y actividades  divertidas ',
          row2_text4:'Videos de expertos que comparten información sobre valores y educación',
          row2_text5:'Acceso ilimitado a la app Lalabum',
          row3_text:'Te ayudamos a activar tu licencia para utilizar la app Mundo Lalabum ',
          row3_text1:'¡Baja la app y',
          row3_text2:'sube sus valores!',
          row3_img1:'./appstore.png',
          row3_img2:'./googleplay.png',
          row4_text1:'En su cumpleaños o en ocasiones especiales regala valores, regala algo que les sirva toda su vida.',
          row4_img1:'./quierosabermas_btn.png',
          register:'REGISTRARME',
          close:'CERRAR',
          login:'Acceder',
          row4_text2:'Adquiere nuestro programa escolar Lalabum',
          
        }
      } else {
        return{
          dialog: false,
          dialog2:false,
          row1_text1:'An app full of fun and good examples so that your children learn values.',
          row1_img:'',
          row1_img1:'iniciarsesion_eng.png',
          row1_img2:'registrate_eng.png',
          row2_text1:'Guide your children through the best path with Lalabum as a companion.',
          row2_text2:'subscribe now and get:',
          row2_img1:'icon_celular.png',
          row2_img2:'icon_monitor.png',
          row2_img3:'icon_tablet.png',
          row2_text3:'Unlimited access to fun material and activities',
          row2_text4:'Expert videos that share information about values ​​and education',
          row2_text5:'Unlimited access to app Lalabum',
          row3_text1:'Download the app and',
          row3_text2:'upgrade their values!',
          row3_img1:'appstore.png',
          row3_img2:'googleplay.png',
          row4_text1:'Would you like a more wholesome experience?',
          row4_img1:'tellmemore.png',
          register:'Register',
          close:'Close',
          login:'Sign In',
          row4_text2:'Acquire our Lalabum school program',
          
        }
      }
      
    },
    methods:{
    /*login: function () {
        let username = this.loginemail 
        let password = this.loginpassword
        let client_id= '5c6c4ada410dfba504749c41';
        let client_secret = 'pP9s493s8xlzADfdMneOEgzrZ3J5l46CLXk5OLE8'
        let grant_type = 'password'
        let scope = '*'
        this.$store.dispatch('login', { grant_type, username, password,client_id,client_secret,scope })
       .then(() => this.$router.push('/padres-descargas'))
       .catch()
      },
      register: function () {
        let id = this.$uuid.v1();
        let data = {
          email: this.email,
          password: this.password,
          license: this.license,
          id_only: id,
          client_id:'5c6c4ada410dfba504749c41',
          platform:'windows'
        }
        this.$store.dispatch('register', data)
        .then(() => this.$router.push('/padres-descargas'))
        .catch()
      }*/
    }
    
  }

</script>
<style>
@import url('https://fonts.googleapis.com/css?family=Fredoka+One|Poppins:300,300i,400,400i,500,500i,600,600i,700,700i');

@media screen and (max-width: 400px) {
  .header_padres {
    display: none;
  }

  .contacto_padres{
    top: 45%;
    color: white;
  }

  .cenefa{    
  top: 91%;
}
}


@media screen and (min-width: 960px) {
  .contacto_padres p{
  
    color: white;
  }

  .contacto_padres{
    top:30%;
  }

  .img_padres{
    margin-left: 50%;
    top:30%;
  }

  
}

/* Encabezado Padres */

.vertical-center{
  padding-left:10%;
  margin: 0px;
  position:absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.vertical-center-mobile{
  /*padding-left:2%;*/
  margin: 0px;
  position:absolute;
  top: 70%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.text-top-rowp{
  font-size:2vw;
  font-family: 'Poppins', sans-serif;
}


.cenefa{    
  top: 90%;
}

/* ---- */

/* Guia a tus hijos */

.text-center{
  font-size:2.5vw;
  padding-top: 2vw;
  text-align: center;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  color: #568BC3;
}

.sub, .text-guia{
  font-weight: 400;
  color: gray;
  font-size:1.3vw;
}

.sub{
  font-weight: 400;
  color: gray;
  font-size:1.5vw;
}

.tools p{
  font-size: 1.1vw;
}

/* ---- */

/* ROW3 */

.title_3{
  font-size: 2vw;
  font-weight: 400;
}

/* ---- */

/* ROW4 */

.contacto_padres{
  padding-left:25%;
  margin: 0px;
  position:absolute;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  text-align: center;
}

.contacto_padres_mobile{
  padding-left:6%;
  margin: 0px;
  top:45%;
  position:absolute;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  text-align: center;
}

/* ---- */







</style>